module.exports = __webpack_public_path__ + "logout.66b72b1aadb00b48ce45.svg";


//////////////////
// WEBPACK FOOTER
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/assets/images/logout.svg
// module id = ../../../../../src/assets/images/logout.svg
// module chunks = styles